import React, { useEffect } from 'react';
import { usePublicData } from '../hooks/usePublicData';
import '../css/Loader.css';

export const Loader: React.FC = () => {
  const { loadReady, state, latestVideos } = usePublicData();

  return (
    <div id="loading-data-screen" style={{ display: !loadReady ? 'flex' : 'none' }}>
      <h1>Data Loading</h1>
      <p>This can take a few moments</p>
      <div className="loader"></div>
      <label htmlFor="progress">Progress:</label>
      <progress id="progress" value={state.count} max={latestVideos.length}></progress>
    </div>
  );
};
